import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface CookiePreferences {
  essential: true;
  analytics: boolean;
  marketing: boolean;
  functional: boolean;
}

interface CookieStore {
  consentGiven: boolean;
  preferences: CookiePreferences;
  preferencesOpen: boolean;

  acceptAll: () => void;
  rejectNonEssential: () => void;
  savePreferences: (prefs: Partial<Omit<CookiePreferences, 'essential'>>) => void;
  openPreferences: () => void;
  closePreferences: () => void;
}

const DEFAULT_PREFS: CookiePreferences = {
  essential: true,
  analytics: false,
  marketing: false,
  functional: false,
};

export const useCookieStore = create<CookieStore>()(
  persist(
    (set) => ({
      consentGiven: false,
      preferences: DEFAULT_PREFS,
      preferencesOpen: false,

      acceptAll: () =>
        set({
          consentGiven: true,
          preferences: { essential: true, analytics: true, marketing: true, functional: true },
        }),

      rejectNonEssential: () =>
        set({ consentGiven: true, preferences: DEFAULT_PREFS }),

      savePreferences: (prefs) =>
        set((s) => ({
          consentGiven: true,
          preferencesOpen: false,
          preferences: { ...s.preferences, ...prefs },
        })),

      openPreferences: () => set({ preferencesOpen: true }),
      closePreferences: () => set({ preferencesOpen: false }),
    }),
    {
      name: 'pvt:cookie-consent',
      partialize: (s) => ({
        consentGiven: s.consentGiven,
        preferences: s.preferences,
      }),
    }
  )
);
